import Title from '@cohort/components-xps/components/Title';
import {AboutBrand} from '@cohort/wallet/components/space/AboutBrand';
import DigitalAssetList from '@cohort/wallet/components/space/DigitalAssetList';
import useSpaceContext from '@cohort/wallet/hooks/useSpaceContext';
import SpacePage from '@cohort/wallet/layouts/space/SpacePage';
import {poll} from '@cohort/wallet/lib/Utils';
import {Fragment, useEffect} from 'react';
import {useTranslation} from 'react-i18next';

const DigitalAssetListPage = (): JSX.Element => {
  const {space, triggerRefresh} = useSpaceContext();
  const {t} = useTranslation('pages', {keyPrefix: 'space.digitalAssetListPage'});

  useEffect(() => {
    if (space !== undefined && space.pendingOrders.length > 0) {
      void poll(triggerRefresh, 2 * 1000, 90); // 2 seconds intervals x 90 retries.
    }
  }, [space, triggerRefresh]);

  if (space === undefined) {
    return <Fragment />;
  }

  return (
    <SpacePage
      title={t('title')}
      leftPanel={<AboutBrand />}
      tracking={{
        namespace: 'digitalAssets.list',
      }}
    >
      <Title content={t('title')} classes="text-2xl mb-4" />
      <DigitalAssetList
        displayMode="grid"
        pendingOrders={space.pendingOrders}
        ownerships={space.activeOwnerships}
      />
    </SpacePage>
  );
};

export default DigitalAssetListPage;
